/* ZIVO · Nuevos ingresos · EPP v5.6.7
 * Replica las tallas capturadas en el paso 1 dentro de la observacion de
 * cada producto EPP. Conserva cualquier observacion manual adicional y
 * dispara el evento input existente para mantener sincronizado el modelo Angular.
 */
(function () {
  'use strict';

  const MODAL_SELECTOR = 'app-personnel-entry-epp-modal';
  const SIZE_SELECTOR =
    'select[formcontrolname="shirt"], select[formcontrolname="pants"], select[formcontrolname="shoes"]';
  const OBSERVATION_SELECTOR =
    'table.product-table tbody input.product-inline-input[type="text"][maxlength="1000"]';
  const SIZE_NOTE_PATTERN =
    /^EPP de nuevo ingreso\.\s*Tallas Camisa:\s*[^.]*\.\s*Pantalón:\s*[^.]*\.\s*Zapatos:\s*[^.]*\.\s*/i;

  let modal = null;
  let modalObserver = null;
  let scheduledFrame = 0;
  const sizes = {
    shirt: '',
    pants: '',
    shoes: '',
  };

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }

  function captureSizes(root) {
    const shirt = root.querySelector('select[formcontrolname="shirt"]');
    const pants = root.querySelector('select[formcontrolname="pants"]');
    const shoes = root.querySelector('select[formcontrolname="shoes"]');

    if (shirt instanceof HTMLSelectElement) sizes.shirt = clean(shirt.value);
    if (pants instanceof HTMLSelectElement) sizes.pants = clean(pants.value);
    if (shoes instanceof HTMLSelectElement) sizes.shoes = clean(shoes.value);
  }

  function hasCompleteSizes() {
    return Boolean(sizes.shirt && sizes.pants && sizes.shoes);
  }

  function buildSizeNote() {
    return (
      'EPP de nuevo ingreso. ' +
      'Tallas Camisa: ' + sizes.shirt + '. ' +
      'Pantalón: ' + sizes.pants + '. ' +
      'Zapatos: ' + sizes.shoes + '.'
    );
  }

  function mergeObservation(currentValue) {
    const current = clean(currentValue);
    const manualObservation = current.replace(SIZE_NOTE_PATTERN, '').trim();
    const sizeNote = buildSizeNote();
    return manualObservation
      ? sizeNote + ' ' + manualObservation
      : sizeNote;
  }

  function syncProductObservations() {
    if (!modal || !modal.isConnected || !hasCompleteSizes()) return;

    const inputs = modal.querySelectorAll(OBSERVATION_SELECTOR);
    inputs.forEach(function (node) {
      if (!(node instanceof HTMLInputElement)) return;
      if (node.disabled) return;

      const nextValue = mergeObservation(node.value);
      if (node.value === nextValue) return;

      node.value = nextValue;
      node.dispatchEvent(new Event('input', { bubbles: true }));
      node.title = nextValue;
    });
  }

  function captureAndSync() {
    if (!modal || !modal.isConnected) return;
    captureSizes(modal);
    syncProductObservations();
  }

  function scheduleSync() {
    if (scheduledFrame) cancelAnimationFrame(scheduledFrame);
    scheduledFrame = requestAnimationFrame(function () {
      scheduledFrame = 0;
      captureAndSync();
    });
  }

  function mountModal(nextModal) {
    if (modal === nextModal) return;

    if (modalObserver) {
      modalObserver.disconnect();
      modalObserver = null;
    }

    modal = nextModal;
    sizes.shirt = '';
    sizes.pants = '';
    sizes.shoes = '';

    if (!modal) return;

    captureSizes(modal);
    modalObserver = new MutationObserver(scheduleSync);
    modalObserver.observe(modal, {
      childList: true,
      subtree: true,
    });
    scheduleSync();
  }

  function discoverModal() {
    const next = document.querySelector(MODAL_SELECTOR);
    mountModal(next instanceof HTMLElement ? next : null);
  }

  document.addEventListener(
    'change',
    function (event) {
      if (!modal) return;
      const target = event.target;
      if (!(target instanceof HTMLSelectElement)) return;
      if (!target.matches(SIZE_SELECTOR)) return;

      captureSizes(modal);
      scheduleSync();
    },
    true,
  );

  const rootObserver = new MutationObserver(discoverModal);
  rootObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  discoverModal();
})();
